import { appsUtil } from "./index";
import { chartNames } from "../consts";

const appsWithPageLoads = (selectedApps) =>
  appsUtil.filterAppsByDashboards(selectedApps, [
    chartNames.PAGE_LOADS,
    chartNames.AVG_PAGE_LOAD_SPEED
  ]);

const appsWithConnectionTime = (selectedApps) =>
  appsUtil.filterAppsByDashboards(selectedApps, [chartNames.CONNECTION_TIME]);

const appsWithDeviceUsage = (selectedApps) =>
  appsUtil.filterAppsByDashboards(selectedApps, [chartNames.IQOS_DEVICE_USAGE]);

const appsWithADStatistic = (selectedApps) =>
  appsUtil.filterAppsByDashboards(selectedApps, [chartNames.AD_STATISTICS]);

const appsWithADPerformance = (selectedApps) =>
  appsUtil.filterAppsByDashboards(selectedApps, [chartNames.DIAGNOSTICS_PERFORMANCE]);

const appsWithADError = (selectedApps) =>
  appsUtil.filterAppsByDashboards(selectedApps, [chartNames.DIAGNOSTICS_ERRORS_READING_PERFOMANCE]);

const appsWithFWUStatistic = (selectedApps) =>
  appsUtil.filterAppsByDashboards(selectedApps, [chartNames.FWU_STATISTICS]);

const appsWithFWUPerformance = (selectedApps) =>
  appsUtil.filterAppsByDashboards(selectedApps, [chartNames.FWU_PERFORMANCE]);

const appsWithFWUErrors = (selectedApps) =>
  appsUtil.filterAppsByDashboards(selectedApps, [chartNames.FWU_ERRORS]);

const appsWithFWUReconnectionTime = (selectedApps) =>
  appsUtil.filterAppsByDashboards(selectedApps, [chartNames.RECONNECTION_TIME_DURING_FWU]);

const appsWithSettingUsage = (selectedApps) =>
  appsUtil.filterAppsByDashboards(selectedApps, [chartNames.SETTING_USAGE]);

const appsWithSettingPerformance = (selectedApps) =>
  appsUtil.filterAppsByDashboards(selectedApps, [chartNames.SETTING_PERFOMANCE]);

const appsWithHealthStatistics = (selectedApps) =>
  appsUtil.filterAppsByDashboards(selectedApps, [chartNames.BATTERY_HEALTH_STATISTICS]);

const appsWithHealthPerformance = (selectedApps) =>
  appsUtil.filterAppsByDashboards(selectedApps, [chartNames.BATTERY_HEALTH_PERFORMANCE]);

const appsWithDeviceConnectionsCount = (selectedApps) =>
  appsUtil.filterAppsByDashboards(selectedApps, [chartNames.IQOS_DEVICE_CONNECTIONS_COUNT]);

const appsWithConnectionsByBrowser = (selectedApps) =>
  appsUtil.filterAppsByDashboards(selectedApps, [chartNames.BROWSER]);

const appsWithConnectionsByOS = (selectedApps) =>
  appsUtil.filterAppsByDashboards(selectedApps, [chartNames.OS]);

const appsWithCompletedDiagnostic = (selectedApps) =>
  appsUtil.filterAppsByDashboards(selectedApps, [chartNames.AD_COUNT]);

const appsWithFWUCount = (selectedApps) =>
  appsUtil.filterAppsByDashboards(selectedApps, [chartNames.FWU_COUNT]);

const eventAppsUtil = {
  appsWithPageLoads,
  appsWithConnectionTime,
  appsWithDeviceUsage,
  appsWithADStatistic,
  appsWithADPerformance,
  appsWithADError,
  appsWithFWUStatistic,
  appsWithFWUPerformance,
  appsWithFWUErrors,
  appsWithFWUReconnectionTime,
  appsWithSettingUsage,
  appsWithSettingPerformance,
  appsWithHealthStatistics,
  appsWithHealthPerformance,
  appsWithDeviceConnectionsCount,
  appsWithConnectionsByBrowser,
  appsWithConnectionsByOS,
  appsWithCompletedDiagnostic,
  appsWithFWUCount
};

export default eventAppsUtil;
